import { useTranslation } from "react-i18next";
import { Card, CardTitle, Col, Container, Row } from "reactstrap";
import StaticHeaderInfo from "components/pages/web/static/staticHeaderInfo";
import QrCodeSmall from "assets/image/qrCodeSmall.png";
import PersonAdd from "assets/image/person-add.png";
import Mark from "assets/image/mark-chat.png";
import Search from "assets/image/manage-search.png";
import Login from "assets/image/login-black.png";
import PersonTik from "assets/image/person-tik.png";
import history from "assets/image/history.png";
import Group from "assets/image/user-group-add.png";
import Change from "assets/image/change-coin.png";
import ChangeDollar from "assets/image/change-dollar.png";
import Credit from "assets/image/credit-score.png";
import Toc from "assets/image/toc-black.png";
import { Link } from "react-router-dom";
import { CardQuestion } from "./faq";
import { isMobile } from "react-device-detect";

const UserGuide = () => {
  const { t } = useTranslation();

  const guideItems = [
    {
      title: "How do I start?",
      array: [
        { text1: "Login and register", icon: Login, group: "start" },
        { text1: "Authentication", icon: PersonTik, group: "start" },
        { text1: "User level upgrade", icon: PersonAdd, group: "start" },
      ],
    },
    {
      title: "How to use a wallet?",
      array: [
        { text1: "Wallet Section", icon: history, group: "wallet" },
        { text1: "Charging wallet", icon: Credit, group: "wallet" },
        {
          text1: "Crypto currency transfer",
          icon: QrCodeSmall,
          group: "wallet",
        },
      ],
    },
    {
      title: "How do I buy and sell?",
      array: [
        { text1: "Toman And Tether Markets", icon: Change, group: "trade" },
        {
          text1: "Buy and sell digital currency",
          icon: QrCodeSmall,
          group: "trade",
        },
        { text1: "Order history", icon: history, group: "trade" },
      ],
    },
    {
      title: "Other panel features!",
      array: [
        { text1: "Invite friends", icon: Group, group: "panel" },
        { text1: "Security setting", icon: history, group: "panel" },
        { text1: "Support section", icon: Mark, group: "panel" },
      ],
    },
  ];

  return (
    <div>
      <StaticHeaderInfo>
        <div className="pb-5">
          <span className="text-light fs-2 fw-bold ">
            {t("Coinnik Market User Guide")}
          </span>
        </div>
      </StaticHeaderInfo>
      <Container className="mt-n5">
        {isMobile ? (
          <>
            {guideItems.map((item) => (
              <>
                <Row className="pb-3">
                  <Col xs="12" md="12" lg="3" xl="3" className="">
                    <Card className="card-warning shadow py-3 border-radius-1">
                      <div className="fs-7 fw-medium  text-white text-center">
                        {t(item.title)}
                      </div>
                    </Card>
                  </Col>
                </Row>
                {item.array.map((item, index) => (
                  <Row className="">
                    <Col xs="12" sm="12" md="12" lg="3" xl="3" className="pb-3">
                      <Link to={"/guide/" + item.group} onClick={() => {}}>
                        <Card className="shadow  border-radius-1 py-3">
                          <Row className=" d-flex align-items-center ">
                            <Col
                              xs="2"
                              className="mx-4 d-flex align-items-center"
                            >
                              <img src={item.icon} width={38} />
                            </Col>
                            <Col
                              xs="8"
                              className="d-flex align-items-center justify-content-between"
                            >
                              <span className="fs-6 fw-medium text-secondary-seven-light">
                                {t(item.text1)}
                              </span>
                              <i className="icon-chevron-left icon-chevron-left-black" />
                            </Col>
                          </Row>
                        </Card>
                      </Link>
                    </Col>
                  </Row>
                ))}
              </>
            ))}
          </>
        ) : (
          <Row className="a">
            {guideItems.map((item, index) => (
              <Col xs="3">
                <Row className="pb-3">
                  <Col xs="12">
                    <Card className="card-warning shadow guide-user-card-style-desktop border-radius-1">
                      <span className="fs-7 fw-medium  text-white text-center">
                        {t(item.title)}
                      </span>
                    </Card>
                  </Col>
                </Row>
                <Row className="pb-5">
                  {item.array.map((item, index) => {
                    return (
                      <Col xs="12" className="pb-3">
                        <Link to={"/guide/" + item.group} onClick={() => {}}>
                          <Card className="shadow  border-radius-1 guide-user-card-mobile">
                            <Row className=" d-flex align-items-center justify-content-center flex-nowrap">
                              <Col xs="2" className="mx-4">
                                <img src={item.icon} />
                              </Col>
                              <Col
                                xs="10"
                                className="d-flex align-items-center "
                              >
                                <span className="fs-6 fw-medium text-secondary-seven-light">
                                  {t(item.text1)}
                                </span>
                              </Col>
                            </Row>
                          </Card>
                        </Link>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            ))}
          </Row>
        )}

        <Row>
          <Col xs="12">
            <CardQuestion />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default UserGuide;
